module.exports = __webpack_public_path__ + "static/media/Word.882375f0.png";